/**
 * Admin panel: users with role `admin` must not be deletable (store owner / main operator).
 * Backend should enforce the same rule.
 */
export function isAdminRoleUser(user) {
  if (!user || typeof user !== 'object') return false;
  const r = String(user.role ?? '').trim().toLowerCase();
  return r === 'admin';
}
